import React from "react";

// Shared popover footer used by every picker, as in the redesign mockup: a "Clear Selection" text link and a
// small primary button, together on the right.
const PickerFooter = ({ onClear, onConfirm, confirmLabel = "Done", clearDisabled = false, confirmDisabled = false }) => {
    return (
        <div className="flex items-center justify-end gap-4">
            <button type="button" onClick={onClear} disabled={clearDisabled}
                className="text-sm font-medium text-sky-600 hover:underline cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed disabled:no-underline">
                Clear Selection
            </button>
            <button type="button" onClick={onConfirm} disabled={confirmDisabled}
                className="oly-btn oly-btn-primary oly-btn--small min-w-28 disabled:opacity-40 disabled:cursor-not-allowed">
                {confirmLabel}
            </button>
        </div>
    );
};
export default PickerFooter;
